export default __webpack_public_path__ + "static/media/my-claim.240ce4a8.jpg";